module.exports = {"620521100":"永清镇","620521101":"红堡镇","620521102":"白驼镇","620521103":"金集镇","620521104":"秦亭镇","620521105":"山门镇","620521106":"白沙镇","620521107":"王河镇","620521108":"郭川镇","620521109":"黄门镇","620521110":"松树镇","620521111":"远门镇","620521112":"土门镇","620521113":"草川铺镇","620521114":"陇东镇","620521206":"贾川乡","620521207":"丰望乡","620521211":"新城乡","620521400":"清水县科技养殖示范园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620521.json
// module id = 2909
// module chunks = 0